import { defineComponent } from 'navigation-components/platform/models';
import { USER_INVITE_MODAL_COMPONENT } from '../constants';
import { getPortalId } from '../../common/utils';
import { capabilities } from '../../capabilities';
export const USER_INVITE_MODAL_IFRAME_ID = 'user-invite-modal-iframe';
export const userInviteModalDef = defineComponent(USER_INVITE_MODAL_COMPONENT, {
  path: `/user-invite-navigation-component/${getPortalId()}`,
  name: USER_INVITE_MODAL_COMPONENT,
  capabilities: [capabilities.HIDE_COMPONENT_CAP.getName()],
  deferLoading: true,
  initiallyFullscreen: true,
  iframeProps: {
    id: USER_INVITE_MODAL_IFRAME_ID
  }
});